
// TYPES
export const types = {
    LOGOUT: "AUTH/LOGOUT",
    LOGIN_REQUEST: "AUTH/LOGIN_REQUEST",
    LOGIN_ERROR: "AUTH/LOGIN_ERROR",
};

// INITIAL STATE
export const initialState = {
    token: null,
    user: null,
    loading: false,
    error: false,
};

// REDUCER
export default function auth(state = initialState, action) {
    switch (action.type) {
        case types.LOGOUT:
            return {
                ...state,
                token: null,
                user: null,
                credentials: null
            };
        case types.LOGIN_REQUEST + "/SUCCESS":
            return {
                ...state,
                token: action.data.data.token,
                user: {
                    id: action.data.data.user.id,
                    username: action.data.data.user.username,
                    email: action.data.data.user.email,
                    phone: action.data.data.user.phone,
                    firstName: action.data.data.user.firstName,
                    lastName: action.data.data.user.lastName,
                    role: action.data.data.user.role
                }
            };
        case types.LOGIN_REQUEST + "/ERROR":
            return {
                ...state,
                token: null,
                user: null
            };
        case types.LOGIN_ERROR:
            return {
                ...state,
                token: null,
                user: null
            };

        default:
            return state;
    }
}

// ACTIONS
export const actions = {

    loginRequest: (credentials) => {
        return {
            type: types.LOGIN_REQUEST,
            $api: {
                method: "login",
                body: {
                    username: credentials.username,
                    password: credentials.password
                }
            }
        };
    },

    logout: () => {
        return {
            type: types.LOGOUT,
            $api: {
                method: "logout",
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/redux/modules/Auth.js